import type { Consult, Patient, Timed } from "../app-patient/_objects-patient";
import { fromBirthDateTo, normalizeDate } from "./date";
import { DataMissingException } from "./exceptions";
import { stdDeviationFor } from "./standard-deviation";

export function getAgeAtThatTime(timed: Timed, patient: Patient) {
  return fromBirthDateTo(
    normalizeDate(patient.year_of_birth),
    normalizeDate(timed.date)
  );
}

export function wh(consult: Consult) {
  if (!consult.height_cm) {
    throw new DataMissingException("Height");
  }
  if (!consult.weight_kg) {
    throw new DataMissingException("Weight");
  }
  return consult.weight_kg / consult.height_cm;
}

export function bmi(consult: Consult): number {
  if (!consult.height_cm) {
    throw new DataMissingException("Height");
  }
  if (!consult.weight_kg) {
    throw new DataMissingException("Weight");
  }
  return (10000 * consult.weight_kg) / (consult.height_cm * consult.height_cm);
}

export function getWeightSd(consult: Consult, patient: Patient): number {
  return stdDeviationFor(
    patient.sex,
    "weight_kg",
    getAgeAtThatTime(consult, patient),
    consult.weight_kg
  );
}

export function getHeightSd(consult: Consult, patient: Patient): number {
  return stdDeviationFor(
    patient.sex,
    "height_cm",
    getAgeAtThatTime(consult, patient),
    consult.height_cm
  );
}

export function getWHSd(consult: Consult, patient: Patient): number {
  return stdDeviationFor(
    patient.sex,
    "wh",
    consult.height_cm,
    consult.weight_kg
  );
}

export function getBMISd(consult: Consult, patient: Patient): number {
  return stdDeviationFor(
    patient.sex,
    "bmi",
    getAgeAtThatTime(consult, patient),
    bmi(consult)
  );
}

export function actualAge(
  patient: Patient,
  reference: Date | string | number = new Date()
): string {
  if (!patient.year_of_birth) {
    return "";
  }
  let birth: Date | string | number = patient.year_of_birth;
  const options: {
    reference: Date | string | number;
  } = {
    reference
  };
  if (typeof options.reference == "number") {
    options.reference = "" + options.reference;
  }
  if (typeof options.reference == "string") {
    if (options.reference.length < 4) {
      return "";
      // throw new Exception('Invalid reference');
    }
    const ry = parseInt(options.reference.substring(0, 4));
    let rm = parseInt(options.reference.substring(5, 7));
    if (isNaN(rm)) {
      rm = 1; // emulate january
    }
    options.reference = new Date(ry, rm - 1, 1);
  }
  if (typeof birth == "number") {
    birth = "" + birth;
  }
  if (typeof birth == "string") {
    if (birth.length < 4) {
      return "";
      // throw new Exception('Invalid birth');
    }
    const by = parseInt(birth.substring(0, 4));
    let bm = parseInt(birth.substring(5, 7));
    if (isNaN(bm)) {
      bm = 1; // emulate january
    }
    birth = new Date(by, bm - 1 - 1, 30);
  }
  const days = new Date(
    0,
    0,
    0,
    0,
    0,
    0,
    options.reference.getTime() - birth.getTime()
  );
  const res = { years: days.getFullYear() - 1900, months: days.getMonth() };
  return res.years + "y" + res.months + "m";
}
